<template>
  <div id="coin_seller_details">
    <van-nav-bar :title="$t('title.coin_seller_details')" placeholder fixed safe-area-inset-top @click-left="onClickLeft" left-arrow />
    <van-row>
     <van-col span="24">
        <van-tabs  v-model="active" @click="onClickTab">
            <van-tab :title="$t('column.all')"></van-tab>
            <van-tab :title="$t('column.gains')"></van-tab>
            <van-tab :title="$t('column.expenses')"></van-tab>
        </van-tabs>
      </van-col>
      <van-col span="22" offset="1" class="coin_seller_details_date">
       <van-cell class="coin_seller_details_date_cell" is-link arrow-direction="down" :value="date ? date : $t('column.select_date')" @click="timeShowBtn" icon="notes-o"/>
      </van-col>
      <van-col span="22" offset="1" class="coin_seller_details_bg">
        <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="$t('other.there_is_no_more')"
            :loading-text="$t('other.Loading')"
            @load="onLoad"
        >
          <van-cell v-for="(item,i) in list" :key="i" class="coin_seller_details_list1">
            <van-col span="24" class="coin_seller_details_list_bg1">
              <van-col span="16" offset="1">
                <van-col span="24" class="coin_seller_details_list_centent1">
                    <div class="coin_seller_details_list_centent_type1">{{ item.text }} {{ item.nick_name }}</div>
                    <div class="coin_seller_details_list_centent_type_uid" v-if="item.nick_name"> ID:{{ item.touid }}({{ item.user_type }}) </div>
                </van-col>
                <van-col span="24" class="coin_seller_details_list_time1">
                  {{ item.create_time }}
                </van-col>
              </van-col>
              <van-col span="6">
                <van-col span="24" class="coin_seller_details_list_coin3">
                   {{ item.coins }}
                </van-col>
                <van-col span="24" class="coin_seller_details_list_balance" v-if="item.coin_balance">
                    {{ item.coin_balance }}
                </van-col>
              </van-col>
            </van-col>
          </van-cell>
        </van-list>
      </van-col>
      <van-calendar v-model="TimeShow" type="range" @confirm="onConfirm" :min-date="minDate" :max-date="maxDate" color="#A529FF" />
    </van-row>
  </div>
</template>

<script>
import '@/assets/css/style.css'
import axios from "axios";

export default {
  data() {
    return {
      typeShow: false,
      TimeShow: false,
      list: [],
      loading: false,
      finished: false,
      page: 1,
      type_list: [
        { id:0, name: this.$t('column.all_type')},
        { id:1, name: this.$t('column.Transfer')},
        { id:2, name: this.$t('column.recharge')},
        { id:3, name: this.$t('column.exchange')}
      ],
      start_date: '',
      end_date: '',
      date: '',
      typeRadioResult: 0,
      active: 0,
       minDate: new Date(2010, 0, 1),
      maxDate: new Date(),
    }
  },
  created() {
    this.get_list()
  },
  methods: {
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    onConfirm(date) {
      const [start, end] = date;
      this.TimeShow = false;
      this.start_date = this.formatDate(start)
      this.end_date = this.formatDate(end)
      this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`
      this.onClickTab()
    },
    onClickTab() {
        this.page = 1
        this.finished = false
        this.get_list()
    },
    timeShowBtn() {
      this.typeRadio = this.typeRadioResult
      this.TimeShow = true
    },
    typeShowSave() {
      this.typeRadioResult = this.typeRadio
      this.TimeShow = false
      this.page = 1
      this.finished = false
      this.get_list()
    },
    onLoad() {
      if (this.page > 1){
        this.get_list()
      }
    },
    get_list() {
        //type：0全部1收益2支出
      this.loading = true;
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=seller_consume_log1", {
        params: {
          uid: uid,
          token: token,
          type: this.active,
          start_date: this.start_date,
          end_date: this.end_date,
          page: this.page
        }
      }).then(res => {
        this.loading = false;
        if (this.page === 1) {
          this.list = []
        }
        for (let j = 0; j < res.data.data.list.length; j++) {
          this.list.push(res.data.data.list[j])
        }
        //如果列表数据条数< 0，不再触发滚动加载
        if (res.data.data.list.length <= 0) {
          this.finished = true
        }
        this.page ++
      })
    },
    onClickLeft() {
      this.$router.go(-1)
    },
  }
}
</script>
<style>

.coin_seller_details_list_bg1 {
  display: flex;
  align-items: flex-start;
}

/* 类型标签样式 */
.coin_seller_details_list_type {
  margin-bottom: 8px;
}

.tag_bg_1 {
  background-color: #ff6b6b;
  color: #fff;
}

.tag_bg_2 {
  background-color: #4ecdc4;
  color: #fff;
}

.tag_bg_3 {
  background-color: #ffe66d;
  color: #333;
}

.tag_bg_4 {
  background-color: #95e1d3;
  color: #333;
}

.tag_bg_5 {
  background-color: #f38181;
  color: #fff;
}

/* 内容区域样式 - 修复超出滚动问题 */
.coin_seller_details_list_centent {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  overflow: hidden;
}

.coin_seller_details_list_centent_type {

  font-size: 14px;
  color: #333;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  min-width: 0;
}

.coin_seller_details_list_centent_avatar {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
}

.coin_seller_details_list_centent_avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 用户信息区域 - 修复超出滚动问题 */
.coin_seller_details_list_centent_user {
  flex-shrink: 0;
  min-width: 80px;
  max-width: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}

.coin_seller_details_list_centent_user_name {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.4;
  margin-bottom: 2px;
}

.coin_seller_details_list_centent_user_id {
  font-size: 12px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.4;
}

/* 时间样式 */
.coin_seller_details_list_time {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}

/* 金币数量样式 */

.coin_seller_details_list_coin1 img,
.coin_seller_details_list_coin2 img {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin-right: 5px;
}

.coin_seller_details_list_coin2 {
  color: #4ecdc4;
  margin-top: 5px;
}

.coin_seller_details_list_balance {
  text-align: right;
  font-size: 0.9rem;
  color: #999;
  margin-top: 3px;
}

/* 弹窗样式 */
.coin_seller_details_popup {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.coin_seller_details_popup_name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  text-align: center;
}

.coin_seller_details_popup_save {
  font-size: 14px;
  color: #ff6b6b;
  text-align: right;
  font-weight: 500;
}

.coin_seller_details_popup_radio {
  padding: 10px 0;
}

/* 响应式样式 */
@media screen and (max-width: 375px) {
  .coin_seller_details_list_centent_type {
    font-size: 13px;
  }
  
  .coin_seller_details_list_centent_avatar {
    width: 35px;
    height: 35px;
  }
  
  .coin_seller_details_list_centent_user {
    min-width: 70px;
    max-width: 100px;
  }
  
  .coin_seller_details_list_centent_user_name {
    font-size: 13px;
  }
  
  .coin_seller_details_list_centent_user_id {
    font-size: 11px;
  }
  
  .coin_seller_details_list_coin1,
  .coin_seller_details_list_coin2 {
    font-size: 14px;
  }
}

@media screen and (max-width: 320px) {
  .coin_seller_details_list {
    padding: 10px;
  }
  
  .coin_seller_details_list_centent_type {
    font-size: 12px;
    -webkit-line-clamp: 1;
  }
  
  .coin_seller_details_list_centent_avatar {
    width: 30px;
    height: 30px;
    margin-right: 8px;
  }
  
  .coin_seller_details_list_centent_user {
    min-width: 60px;
    max-width: 80px;
  }
  
  .coin_seller_details_list_centent_user_name {
    font-size: 12px;
  }
  
  .coin_seller_details_list_centent_user_id {
    font-size: 10px;
  }
  
  .coin_seller_details_list_coin1,
  .coin_seller_details_list_coin2 {
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/coin_seller_details1.vue